<label (click)="createMFA($event)"
       [class.disabled]="isInProgress"
       class="wrapper">
    <img alt="Resend Access Point Code"
         height="28"
         ngSrc="assets/icons/blue/password.svg"
         width="29">
    <span class="label-text">{{ 'viewAccessPointCode.label' | translate }}</span>
</label>

@if (isInProgress) {
    <span class="spinner">
        <mat-spinner diameter="24"></mat-spinner>
    </span>
}
